// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"45e8efa8","936":"45e8efa8"}[chunkId] + ".chunk.css";
};